import React from "react";

import { useCloseModal } from "common/Modals";
import SVGIcon from "common/SVGIcon";

const RetainCrossSellModal = () => {
    const hideModal = useCloseModal();
    const learnMoreURL =
        "https://get.workstep.com/retain_demo" +
        "?utm_campaign=Website%20-%20Retain%20Demo&utm_source=In_app";
    return (
        <div className="ws-modal ws-modal-small retain-cross-sell-modal heap-retain-cross-sell-modal">
            <h2>
                Struggling to retain your workforce?
                <br />
                We have a solution for that.
            </h2>
            <SVGIcon
                icon="close"
                onClick={hideModal}
                className="heap-retain-cross-sell-modal__close"
            />
            <div className="ws-modal-body">
                <p>
                    Increase retention across your entire workforce with real-time, actionable
                    feedback and insights from your frontline with WorkStep RETAIN.
                </p>
                <div className="btn-wrapper">
                    <a
                        href={learnMoreURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary heap-retain-cross-sell-modal__learn-more-link"
                    >
                        Learn More
                    </a>
                </div>
            </div>
        </div>
    );
};

export default RetainCrossSellModal;
